<template lang="pug">
.LndAreasOfWork
  h2(v-html="L.header")

  .__list
    //- h2(v-html="L.header2")
    ul
      li(v-for="(item, i) of L.list", @click="handleItemClick(item)")
        Svgi.__icon(:name="`areas-${ i + 1 }`")
        h5(v-html="item.header")
        span(v-html="item.text")
        router-link(v-if="item.link", :to="item.link" @click.stop) Learn more
        a(v-if="item.extLink", :href="item.extLink" @click.stop) Learn more

</template>
<script>
import ROUTES from 'routes';
import content from 'content';
import { on } from 'services/emitter';

export default {
  name: 'LndAreasOfWork',
  inject: ['mq'],
  mixins: [
    on({
      'resize': 'setRowHeight',
    }),
  ],

  static: () => ({
    L: content.areasOfWork,
  }),

  methods: {
    setRowHeight () {
      const $headers = [...this.$el.querySelectorAll('li h5')];
      const $spans = [...this.$el.querySelectorAll('li span')];

      function setMaxHeight ($els) {
        $els.forEach($el => $el.style.height = '');
        const maxHeight = Math.max(...$els.map($el => $el.offsetHeight));
        $els.forEach($el => $el.style.height = `${ maxHeight }px`);
      }

      setMaxHeight($headers);
      setMaxHeight($spans);
    },

    handleItemClick (item) {
      if (item.link)
        this.$router.push({ path: item.link });
      else if (item.extLink)
        window.location.href = item.extLink;
    },
  },

  mounted () {
    this.$nextTick(this.setRowHeight);
  },
};

</script>
<style>
.LndAreasOfWork {
  .__list > ul {
    display: flex;
    flex-direction: row;

    > li {
      display: flex;
      flex: 0 1;

      a {
        height: 40px;
        margin-top: 22px;

        line-height: 36px;
        text-align: center;

        border: 1px solid var(--border-c);
      }
    }
  }

  .__list {
    h2 { margin-bottom: 24px; }

    > ul {
      /*--gap-h: calc(44 / var(--vw-scale));*/

      > li {
        flex-direction: column;
        min-width: 150px;

        > h5 {
          display: block;
          margin-bottom: 2em;

          font-weight: bold;
        }

        &:last-child { cursor: pointer; }
      }
    }
  }

  .__icon {
    width: 25px;
    height: 25px;
    margin-bottom: 30px;
  }
}

@media (min-width: 740px) {
  .LndAreasOfWork {
    h2 { margin-bottom: 80px }
    .__list > ul {
      display: flex;
      margin: 0 -22px;

      > li {
        flex-grow: 2;
        padding: 22px;

        cursor: pointer;

        a { opacity: .5; }
        span { margin-bottom: 22px }

        &:hover {
          background: rgba(255, 255, 255, .1);

          a { opacity: 1; }
        }
      }
    }

    .__list {
      line-height: 28px;
    }
  }
}

@media (max-width: 739px) {
  .LndAreasOfWork {
    .__list > ul {
      flex-direction: column;

      > li {
        display: flex;
        flex: 2 0 calc((100% - 128px - var(--gap) * 4) / 5);

      }
    }

    .__list {
      line-height: 35px;
      > ul { --gap: 30px; }
    }

    .__icon {
      margin-top: 32px;
    }
  }
}
</style>
